export default __webpack_public_path__ + "static/media/bad.5ba423ac.jpg";